import Vue from 'vue'

export default new Vue({
    methods: {
        setPaginaAlterada(pagina){
            this.$emit('pagina-alterada', pagina)
        },

        onPaginaAlterada(callback){
            this.$on('pagina-alterada', callback)
        },

        setSalvarNovoEvento(){
            this.$emit('novoEvento')
        },

        onSalvarNovoEvento(callback){
            this.$on('novoEvento', callback)
        },

        setFecharDoacoes(texto){
            this.$emit('fecharDoacoes', texto)
        },

        onFecharDoacoes(callback){
            this.$on('fecharDoacoes', callback)
        },

        setFecharEdicaoEvento(fechar){
            this.$emit('fecharEdicaoEvento', fechar)
        },

        onFecharEdicaoEvento(callback){
            this.$on('fecharEdicaoEvento', callback)
        },

        setFecharIniciado(fechar){
            this.$emit('fecharIniciado', fechar)
        },

        onFecharIniciado(callback){
            this.$on('fecharIniciado', callback)
        },

        setFecharEdicaoPerfil(fechar){
            this.$emit('fecharEdicaoPerfil', fechar)
        },

        onFecharEdicaoPerfil(callback){
            this.$on('fecharEdicaoPerfil', callback)
        },

        setEditarPassagem(passagem){
            this.$emit('editarPassagem', passagem)
        },

        onEditarPassagem(callback){
            this.$on('editarPassagem', callback)
        },

        setExcluirPassagem(passagem){
            this.$emit('excluirPassagem', passagem)
        },

        onExcluirPassagem(callback){
            this.$on('excluirPassagem', callback)
        },

        setEditarHistoricoCla(cla){
            this.$emit('editarHistoricoCla', cla)
        },

        onEditarHistoricoCla(callback){
            this.$on('editarHistoricoCla', callback)
        },

        setExcluirHistoricoCla(cla){
            this.$emit('excluirHistoricoCla', cla)
        },

        onExcluirHistoricoCla(callback){
            this.$on('excluirHistoricoCla', callback)
        },

        setEditarTitulo(titulo){
            this.$emit('editarTitulo', titulo)
        },

        onEditarTitulo(callback){
            this.$on('editarTitulo', callback)
        },

        setExcluirTitulo(titulo){
            this.$emit('excluirTitulo', titulo)
        },

        onExcluirTitulo(callback){
            this.$on('excluirTitulo', callback)
        },

        setAbrirIniciado(abrir){
            this.$emit('abrirIniciado', abrir)
        },

        onAbrirIniciado(callback){
            this.$on('abrirIniciado', callback)
        },

        setAbrirNovoIniciado(abrir){
            this.$emit('abrirNovoIniciado', abrir)
        },

        onAbrirNovoIniciado(callback){
            this.$on('abrirNovoIniciado', callback)
        },





        setEditarAviso(aviso){
            this.$emit('editarAviso', aviso)
        },

        onEditarAviso(callback){
            this.$on('editarAviso', callback)
        },

        setExcluirAviso(aviso){
            this.$emit('excluirAviso', aviso)
        },

        onExcluirAviso(callback){
            this.$on('excluirAviso', callback)
        },

        setAvisoExcluido(aviso){
            this.$emit('avisoExcluido', aviso)
        },

        onAvisoExcluido(callback){
            this.$on('avisoExcluido', callback)
        },

        setNovoAviso(aviso){
            this.$emit('novoAviso', aviso)
        },

        onNovoAviso(callback){
            this.$on('novoAviso', callback)
        },

        setAvisoCadastrado(aviso){
            this.$emit('avisoCadastrado', aviso)
        },

        onAvisoCadastrado(callback){
            this.$on('avisoCadastrado', callback)
        },

        setAvisoAtualizado(aviso){
            this.$emit('avisoAtualizado', aviso)
        },

        onAvisoAtualizado(callback){
            this.$on("avisoAtualizado", callback)
        },


        

        setEditarCategoria(categoria){
            this.$emit('editarCategoria', categoria)
        },

        onEditarCategoria(callback){
            this.$on('editarCategoria', callback)
        },

        setExcluirCategoria(categoria){
            this.$emit('excluirCategoria', categoria)
        },

        onExcluirCategoria(callback){
            this.$on('excluirCategoria', callback)
        },

        setCategoriaExcluida(categoria){
            this.$emit('categoriaExcluida', categoria)
        },

        onCategoriaExcluida(callback){
            this.$on('categoriaExcluida', callback)
        },

        setNovaCategoria(categoria){
            this.$emit('novaCategoria', categoria)
        },

        onNovaCategoria(callback){
            this.$on('novaCategoria', callback)
        },

        setCategoriaCadastrada(categoria){
            this.$emit('categoriaCadastrada', categoria)
        },

        onCategoriaCadastrada(callback){
            this.$on('categoriaCadastrada', callback)
        },

        setCategoriaAtualizada(categoria){
            this.$emit('categoriaAtualizada', categoria)
        },

        onCategoriaAtualizada(callback){
            this.$on("categoriaAtualizada", callback)
        },






        setEditarMotivo(motivo){
            this.$emit('editarMotivo', motivo)
        },

        onEditarMotivo(callback){
            this.$on('editarMotivo', callback)
        },

        setExcluirMotivo(motivo){
            this.$emit('excluirMotivo', motivo)
        },

        onExcluirMotivo(callback){
            this.$on('excluirMotivo', callback)
        },

        setMotivoExcluido(motivo){
            this.$emit('motivoExcluido', motivo)
        },

        onMotivoExcluido(callback){
            this.$on('motivoExcluido', callback)
        },

        setNovoMotivo(motivo){
            this.$emit('novoMotivo', motivo)
        },

        onNovoMotivo(callback){
            this.$on('novoMotivo', callback)
        },

        setMotivoCadastrado(motivo){
            this.$emit('motivoCadastrado', motivo)
        },

        onMotivoCadastrado(callback){
            this.$on('motivoCadastrado', callback)
        },

        setMotivoAtualizado(motivo){
            this.$emit('motivoAtualizado', motivo)
        },

        onMotivoAtualizado(callback){
            this.$on("motivoAtualizado", callback)
        },






        setEditarTipoAtendimento(tipo){
            this.$emit('editarTipoAtendimento', tipo)
        },

        onEditarTipoAtendimento(callback){
            this.$on('editarTipoAtendimento', callback)
        },

        setExcluirTipoAtendimento(tipo){
            this.$emit('excluirTipoAtendimento', tipo)
        },

        onExcluirTipoAtendimento(callback){
            this.$on('excluirTipoAtendimento', callback)
        },

        setTipoAtendimentoExcluido(tipo){
            this.$emit('TipoAtendimentoExcluido', tipo)
        },

        onTipoAtendimentoExcluido(callback){
            this.$on('TipoAtendimentoExcluido', callback)
        },

        setNovoTipoAtendimento(tipo){
            this.$emit('novoTipoAtendimento', tipo)
        },

        onNovoTipoAtendimento(callback){
            this.$on('novoTipoAtendimento', callback)
        },

        setTipoAtendimentoCadastrado(tipo){
            this.$emit('TipoAtendimentoCadastrado', tipo)
        },

        onTipoAtendimentoCadastrado(callback){
            this.$on('TipoAtendimentoCadastrado', callback)
        },

        setTipoAtendimentoAtualizado(tipo){
            this.$emit('TipoAtendimentoAtualizado', tipo)
        },

        onTipoAtendimentoAtualizado(callback){
            this.$on("TipoAtendimentoAtualizado", callback)
        },








        setEditarCla(cla){
            this.$emit('editarCla', cla)
        },

        onEditarCla(callback){
            this.$on('editarCla', callback)
        },

        setExcluirCla(cla){
            this.$emit('excluirCla', cla)
        },

        onExcluirCla(callback){
            this.$on('excluirCla', callback)
        },

        setClaExcluido(cla){
            this.$emit('claExcluido', cla)
        },

        onClaExcluido(callback){
            this.$on('claExcluido', callback)
        },

        setNovoCla(cla){
            this.$emit('novoCla', cla)
        },

        onNovoCla(callback){
            this.$on('novoCla', callback)
        },

        setClaCadastrado(cla){
            this.$emit('claCadastrado', cla)
        },

        onClaCadastrado(callback){
            this.$on('claCadastrado', callback)
        },

        setClaAtualizado(cla){
            this.$emit('claAtualizado', cla)
        },

        onClaAtualizado(callback){
            this.$on("claAtualizado", callback)
        },




        setEditarLocal(local){
            this.$emit('editarLocal', local)
        },

        onEditarLocal(callback){
            this.$on('editarLocal', callback)
        },

        setExcluirLocal(local){
            this.$emit('excluirLocal', local)
        },

        onExcluirLocal(callback){
            this.$on('excluirLocal', callback)
        },

        setLocalExcluido(local){
            this.$emit('localExcluido', local)
        },

        onLocalExcluido(callback){
            this.$on('localExcluido', callback)
        },

        setNovoLocal(local){
            this.$emit('novoLocal', local)
        },

        onNovoLocal(callback){
            this.$on('novoLocal', callback)
        },

        setLocalCadastrado(local){
            this.$emit('localCadastrado', local)
        },

        onLocalCadastrado(callback){
            this.$on('localCadastrado', callback)
        },

        setLocalAtualizado(local){
            this.$emit('localAtualizado', local)
        },

        onLocalAtualizado(callback){
            this.$on("localAtualizado", callback)
        },






        setEditarTipo(tipo){
            this.$emit('editarTipo', tipo)
        },

        onEditarTipo(callback){
            this.$on('editarTipo', callback)
        },

        setExcluirTipo(tipo){
            this.$emit('excluirTipo', tipo)
        },

        onExcluirTipo(callback){
            this.$on('excluirTipo', callback)
        },

        setTipoExcluido(tipo){
            this.$emit('tipoExcluido', tipo)
        },

        onTipoExcluido(callback){
            this.$on('tipoExcluido', callback)
        },

        setNovoTipo(tipo){
            this.$emit('novoTipo', tipo)
        },

        onNovoTipo(callback){
            this.$on('novoTipo', callback)
        },

        setTipoCadastrado(tipo){
            this.$emit('tipoCadastrado', tipo)
        },

        onTipoCadastrado(callback){
            this.$on('tipoCadastrado', callback)
        },

        setTipoAtualizado(tipo){
            this.$emit('tipoAtualizado', tipo)
        },

        onTipoAtualizado(callback){
            this.$on("tipoAtualizado", callback)
        },




        setEditarStatus(status){
            this.$emit('editarStatus', status)
        },

        onEditarStatus(callback){
            this.$on('editarStatus', callback)
        },

        setExcluirStatus(status){
            this.$emit('excluirStatus', status)
        },

        onExcluirStatus(callback){
            this.$on('excluirStatus', callback)
        },

        setStatusExcluido(status){
            this.$emit('statusExcluido', status)
        },

        onStatusExcluido(callback){
            this.$on('statusExcluido', callback)
        },

        setNovoStatus(status){
            this.$emit('novoStatus', status)
        },

        onNovoStatus(callback){
            this.$on('novoStatus', callback)
        },

        setStatusCadastrado(status){
            this.$emit('statusCadastrado', status)
        },

        onStatusCadastrado(callback){
            this.$on('statusCadastrado', callback)
        },

        setStatusAtualizado(status){
            this.$emit('statusAtualizado', status)
        },

        onStatusAtualizado(callback){
            this.$on("statusAtualizado", callback)
        },


        
        
        setEditarPublicacao(publicacao){
            this.$emit('editarPublicacao', publicacao)
        },

        onEditarPublicacao(callback){
            this.$on('editarPublicacao', callback)
        },

        setExcluirPublicacao(publicacao){
            this.$emit('excluirPublicacao', publicacao)
        },

        onExcluirPublicacao(callback){
            this.$on('excluirPublicacao', callback)
        },

        setPublicacaoExcluida(publicacao){
            this.$emit('PublicacaoExcluida', publicacao)
        },

        onPublicacaoExcluida(callback){
            this.$on('PublicacaoExcluida', callback)
        },

        setNovaPublicacao(publicacao){
            this.$emit('novaPublicacao', publicacao)
        },

        onNovaPublicacao(callback){
            this.$on('novaPublicacao', callback)
        },

        setPublicacaoAtualizada(publicacao){
            this.$emit('publicacaoAtualizada', publicacao)
        },

        onPublicacaoAtualizada(callback){
            this.$on('publicacaoAtualizada', callback)
        },

        setPublicacaoCadastrada(publicacao){
            this.$emit('publicacaoCadastrada', publicacao)
        },

        onPublicacaoCadastrada(callback){
            this.$on('publicacaoCadastrada', callback)
        },



        setAbrirPublicacoesPendentes(publicacoes){
            this.$emit('abrirPublicacoesPendentes', publicacoes)
        },
        onAbrirPublicacoesPendentes(callback){
            this.$on('abrirPublicacoesPendentes', callback)
        },
        setAbrirPublicacoesAprovadas(publicacoes){
            this.$emit('abrirPublicacoesAprovadas', publicacoes)
        },
        onAbrirPublicacoesAprovadas(callback){
            this.$on('abrirPublicacoesAprovadas', callback)
        },
        setAbrirPublicacoesReprovadas(publicacoes){
            this.$emit('abrirPublicacoesReprovadas', publicacoes)
        },
        onAbrirPublicacoesReprovadas(callback){
            this.$on('abrirPublicacoesReprovadas', callback)
        },
        setAbrirPublicacoesInativas(publicacoes){
            this.$emit('abrirPublicacoesInativas', publicacoes)
        },
        onAbrirPublicacoesInativas(callback){
            this.$on('abrirPublicacoesInativas', callback)
        },
        setPublicacaoReprovada(publicacao){
            this.$emit('publicacaoReprovada', publicacao)
        },
        onPublicacaoReprovada(callback){
            this.$on('publicacaoReprovada', callback)
        },
        setPublicacaoInativada(publicacao){
            this.$emit('publicacaoInativada', publicacao)
        },
        onPublicacaoInativada(callback){
            this.$on('publicacaoInativada', callback)
        },
        setLerPublicacao(publicacao){
            this.$emit('lerPublicacao', publicacao)
        },
        onLerPublicacao(callback){
            this.$on('lerPublicacao', callback)
        },
        setPublicacaoAprovada(publicacao){
            this.$emit('publicacaoAprovada', publicacao)
        },
        onPublicacaoAprovada(callback){
            this.$on('publicacaoAprovada', callback)
        },
        setPublicacaoAtivada(publicacao){
            this.$emit('publicacaoAtivada', publicacao)
        },
        onPublicacaoAtivada(callback){
            this.$on('publicacaoAtivada', callback)
        },


        

        setAbrirPassagensPerfil(id){
            this.$emit('abrirPassagensPerfil', id)
        },
        onAbrirPassagensPerfil(callback){
            this.$on('abrirPassagensPerfil', callback)
        },



        setNavOpen(){
            this.$emit('setNavOpen')
        },

        setNavClose(){
            this.$emit('setNavClose')
        },

        onNavOpen(callback){
            this.$on('setNavOpen', callback)
        },
        // onNavClose(callback){
        //     this.$on('setNavClose', callback)
        // },
    }
})
